export const PREFIX_URL = '/diversas';
export const generateURL = (url: string) => `${PREFIX_URL}${url}`;
